module.exports = __webpack_public_path__ + "static/media/5_VP_Inez Wu min.e65fe6a3.jpg";